// Client for the public lead-capture rail (POST /leads). Used in-app by the
// coverage waitlist: when a drawn area has no DEM coverage, the user can ask
// to be notified when it gains support. The magnet ('coverage-waitlist') must
// exist and be active in the lead_magnets registry.
import { grpcClientFactory } from './grpcClientFactory';
const COVERAGE_WAITLIST_MAGNET_SLUG = 'coverage-waitlist';
export async function joinCoverageWaitlist(input) {
    var _a, _b;
    const lats = input.coordinates.map((c) => c.lat);
    const lngs = input.coordinates.map((c) => c.lng);
    const body = {
        magnet_slug: COVERAGE_WAITLIST_MAGNET_SLUG,
        email: input.email,
        first_name: (_a = input.firstName) !== null && _a !== void 0 ? _a : '',
        answers: {
            kind: input.kind,
            project_name: input.projectName,
            area_acres: input.areaAcres,
            bbox: {
                west: Math.min(...lngs),
                east: Math.max(...lngs),
                south: Math.min(...lats),
                north: Math.max(...lats),
            },
            note: (_b = input.note) !== null && _b !== void 0 ? _b : '',
        },
        landing: window.location.href,
    };
    const res = await grpcClientFactory.fetchApi('/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const payload = await res.json().catch(() => ({ success: false }));
    if (!res.ok || !payload.success) {
        throw new Error(payload.error || 'Failed to join the waitlist');
    }
}
